import {Action, Product, ReplacementsState} from './types'

export const setMainProductReplacement = (selectedMainProductReplacement?: Product) => ({
    type: 'SET_MAIN_PRODUCT_REPLACEMENT',
    payload: {selectedMainProductReplacement,},
})

export const setSecondaryDeviceReplacement = (selectedSecondaryDeviceReplacement?: Product) => ({
    type: 'SET_SECONDARY_DEVICE_REPLACEMENT',
    payload: {selectedSecondaryDeviceReplacement,},
})

const replacementsReducer: React.Reducer<ReplacementsState, Action> = (state, action) => {
    switch (action.type) {
        case 'SET_MAIN_PRODUCT_REPLACEMENT':
            return {
                ...state,
                selectedMainProductReplacement:
                action.payload.selectedMainProductReplacement,
            }
        case 'SET_SECONDARY_DEVICE_REPLACEMENT':
            return {
                ...state,
                selectedSecondaryDeviceReplacement:
                action.payload.selectedSecondaryDeviceReplacement,
            }

        default:
            return state
    }
}

export default replacementsReducer
